module.exports = __webpack_public_path__ + "img/analytics-global@2x.49cadfba.jpg";